export const CONSUME_HASH_START = 'CONSUME_HASH_START';
export const CONSUME_HASH_SUCCESS = 'CONSUME_HASH_SUCCESS';
export const CONSUME_HASH_FAIL = 'CONSUME_HASH_FAIL';
export const CONSUME_HASH_RESET = 'CONSUME_HASH_RESET';
